const issueCategories = state => state.issueCategories;

export {
  issueCategories,
}